import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { WITHDRAWAL_REASON_URL, WITHDRAWAL_URL } from '../../utils/urls';
import instance from '../../services/services';

function LeaveMembership ({ isPopup, setIsPopup }){
  const location = useLocation();
  const [reasonList, setReasonList] = useState([]);
  const [popupActive, setPopupActive] = useState(false);
  const [selectedReason, setSelectedReason] = useState(''); // 선택한 사유 코드
  const [otherReason, setOtherReason] = useState(''); // 기타 사유 텍스트
  
  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  // 회원 탈퇴 사유 리스트
  useEffect(() => {
    const fetchReasonList = async () => {
      try {
        const response = await instance.post(WITHDRAWAL_REASON_URL);
        setReasonList(response.data.data);
      } catch (error) {
        console.error('회원 탈퇴 사유 리스트 조회 오류:', error);
      }
    }
    fetchReasonList();
  }, []);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);
  };
  
  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  // 라디오 버튼 변경 핸들러
  const handleReasonChange = (e) => {
    setSelectedReason(e.target.value);
  };

  // 기타 사유 입력 핸들러
  const handleOtherReasonChange = (e) => {
    setOtherReason(e.target.value);
  };

  // 탈퇴하기 버튼 클릭 핸들러
  const handleConfirm = async () => {
    if (!selectedReason) {
      alert('탈퇴 사유를 선택해주세요.');
      return;
    }

    try {
      // 선택한 사유 정보 찾기
      const selectedReasonInfo = reasonList.find(reason => reason.codecd === selectedReason);
      
      if (!selectedReasonInfo) {
        alert('유효하지 않은 사유입니다.');
        return;
      }

      // API 요청 데이터
      const requestData = {
        leave_reason_code: selectedReasonInfo.codecd,
        leave_reason_msg: selectedReasonInfo.value === '기타(직접입력)' ? otherReason : selectedReasonInfo.value
      };

      // 탈퇴 API 호출
      const response = await instance.post(WITHDRAWAL_URL, requestData);
      
      if (response.data.code === 200) {
        alert('회원 탈퇴가 완료되었습니다.');
        setIsPopup(false);
        // 로그아웃 처리 또는 메인 페이지로 이동 등 추가 처리
        window.location.href = '/';
      } else {
        alert(response.data.message || '회원 탈퇴에 실패했습니다.');
      }
    } catch (error) {
      console.error('회원 탈퇴 오류:', error);
      alert('회원 탈퇴 중 오류가 발생했습니다.');
    }
  };

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content s ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className='pop_title line'>회원 탈퇴</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>

              <div className='p3_box'>
                <h3 className='p3'>회원님, 정말 떠나실 건가요?</h3>
                <p className='g-90 b1_2'>
                  저희 서비스를 이용해 주셔서 진심으로 감사드립니다.<br/>
                  이용하시면서 느끼셨던 점이나 소중한 의견을 공유해 주신다면, 더욱 풍성하고 만족스러운 서비스를 제공할 수 있도록 최선을 다하겠습니다. 앞으로도 더 나은 경험을 선사하기 위해 끊임없이 노력하겠습니다.
                </p>
              </div>

              <div className="default_radio flex-12 column">
                {reasonList.map((reason) => (
                  <div key={reason.codecd}>
                    <input 
                        type="radio" 
                        name="leaveReason" 
                        id={`reason_${reason.codecd}`}
                        value={reason.codecd}
                        onChange={handleReasonChange}
                        checked={selectedReason === reason.codecd}
                    />
                    <label htmlFor={`reason_${reason.codecd}`}>{reason.value}</label>
                  </div>
                ))}
              </div>

              {/* 기타 입력란 - 기타 선택 시에만 표시 */}
              {selectedReason === '6' && (
                <div className='flex-12 other_box'>
                  <div className="default_input">
                    <input
                      type="text"
                      value={otherReason}
                      onChange={handleOtherReasonChange}
                      placeholder="탈퇴 사유를 입력해주세요"
                      className="w-half"
                    />
                  </div>
                </div>
              )}

              <div className='pop_btn_wrap'>
                <button 
                  type="button"
                  className="default_btn black pop_con_btn" 
                  onClick={handleConfirm}
                >
                  탈퇴하기
                </button>
              </div>
            </div>
          </div>
        </div>
    );
};

export default LeaveMembership;